import { SET_QUOTES_EXPAND } from './constants';

let initialState = {
  isQuotesExpanded: false
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_QUOTES_EXPAND:
      return { ...state, isQuotesExpanded: action.isQuotesExpanded };
    default:
      return state;
  }
}

export default reducer;
